import { Log } from 'ng2-logger';
import { Common } from '../../core/common';
import { ActivityTypeEnums } from '../../models/enums/ActivityType';
import { VideoType } from '../../models/enums/VideoType';
import { GlobalState } from '../../models/action/core.d';
import Moment from 'moment';
import { IExamData, IExamQuestionWeights } from '../../models/action/exam';
import { ExamQuestionWeightingType } from '../../models/enums/ExamQuestionWeightingType';

const _logger = Log.create('add-activity-functions');
const _common = new Common();



export function initSubmitValuesForApi(props: any, values: any, activityType: ActivityTypeEnums, classId?: string) {
    let isUpdate = props.updateActivityId && props.updateActivityId.length > 0 

    values.selectedClass = setSelectedClass(values.selectedClass, classId, isUpdate);
    
    values.selectedActivityUnitsTagIds = _common.toStringArray(values.selectedActivityUnitsTagIds,isUpdate);

    values.selectedActivityOwnersTagIds = _common.toStringArray(values.selectedActivityOwnersTagIds,isUpdate);

    values.prerequisiteActivityId = setPrerequisiteActivityId(values.prerequisiteActivityId, values.isActivityPrerequisite);

    values.datePrerequisiteActivityId = datePrerequisiteActivityId(values);

    values.datePrerequisiteActivityHours = prerequisiteActivityHours(values);

    values.taskDeadline = setTaskDeadline(values.taskDeadline, values.taskDeadlinetime, props.userPreferences);

    values.customProperty5 = setCustomProperty5(values.customProperty5Date, values.customProperty5Time, values.customProperty5, props.userPreferences, activityType);
    
    const formattedactivityConditionalBeginDate =
        values.activityBeginDate && values.activityBeginTime
            ? Moment(
                values.activityBeginDate,
                _common.findDateFormat(props.userPreferences) + ' ' +  values.activityBeginTime,
                window.appSettings.DefaultDateTimeFormat
            )
            : '';
    values.activityConditionalBeginDate = formattedactivityConditionalBeginDate
        ? Moment(formattedactivityConditionalBeginDate)
            .set({
                h: Moment(values.activityBeginTime, window.appSettings.DefaultDateTimeFormat).get('hour'),
                m: Moment(values.activityBeginTime, window.appSettings.DefaultDateTimeFormat).get('minute')
            }).format(window.appSettings.DefaultDateFormatApi)
        : '';

    const formattedactivityConditionalEndDate =
        values.activityEndDate && values.activityEndTime
            ? Moment(
                values.activityEndDate,
                _common.findDateFormat(props.userPreferences) + ' ' + values.activityEndTime,
                window.appSettings.DefaultDateTimeFormat
            )
            : '';
    values.activityConditionalEndDate = formattedactivityConditionalEndDate
        ? Moment(formattedactivityConditionalEndDate)
            .set({
                h: Moment(values.activityEndTime, window.appSettings.DefaultDateTimeFormat).get('hour'),
                m: Moment(values.activityEndTime, window.appSettings.DefaultDateTimeFormat).get('minute')
            }).format(window.appSettings.DefaultDateFormatApi)
        : '';

    values.courseId = props.coursePageActivityId;
    if (props.updateActivityId) {
        values.activityId = props.updateActivityId;
    }

    if (activityType === ActivityTypeEnums.Exam) {
        initExamSubmitData(props, values);
    }

    if (props.assignedStudentDatas?.users && props.assignedStudentDatas.users.length > 0) {
        values.ActivityUserIds = props.assignedStudentDatas.users.map((item: any) => item.userId);
    } else {
        values.ActivityUserIds = [];
    }
}

const setSelectedClass = (selectedClass: any, classId: any, isUpdate: boolean) => {
    if(classId)
    {
        selectedClass = [classId];
    }
    else if(selectedClass){
        selectedClass = _common.toStringArray(selectedClass, isUpdate)
    }
    else{
        selectedClass = [];
    }
    return selectedClass;
}

const setCustomProperty5 = (customProperty5Date: any, customProperty5Time: any, customProperty5: any, userPreferences: any, activityType: ActivityTypeEnums) => {
    const _formattedCustomProp5Time =
        customProperty5Date && customProperty5Time
            ? Moment(
                customProperty5Date,
                _common.findDateFormat(userPreferences) + ' ' + customProperty5Time,
                window.appSettings.DefaultDateTimeFormat
            )
            : '';
    if (activityType !== ActivityTypeEnums.Exam) {
        customProperty5 = _formattedCustomProp5Time
            ? Moment(_formattedCustomProp5Time)
                .set({
                    h: Moment(customProperty5Time, window.appSettings.DefaultDateTimeFormat).get('hour'),
                    m: Moment(customProperty5Time, window.appSettings.DefaultDateTimeFormat).get('minute')
                }).format(window.appSettings.DefaultDateFormatApi)
            : '';
    }

        return customProperty5;
}

const setTaskDeadline = (taskDeadline: any, taskDeadlinetime: any, userPreferences: any) => {
    const _formattedTime =
        taskDeadline && taskDeadlinetime
            ? Moment(
                taskDeadline,
                _common.findDateFormat(userPreferences) + ' ' + taskDeadlinetime,
                window.appSettings.DefaultDateTimeFormat
            )
            : '';

    taskDeadline = _formattedTime
        ? Moment(_formattedTime)
            .set({
                h: Moment(taskDeadlinetime, window.appSettings.DefaultDateTimeFormat).get('hour'),
                m: Moment(taskDeadlinetime, window.appSettings.DefaultDateTimeFormat).get('minute')
            }).format(window.appSettings.DefaultDateFormatApi)
        : '';

        return taskDeadline;
}

const setPrerequisiteActivityId = (prerequisiteActivityId: any, isActivityPrerequisite: boolean) => {
    if(!isActivityPrerequisite)
    {
        prerequisiteActivityId = '';
    }

    return prerequisiteActivityId;
}

export function initExamSubmitData(props: any, values: IExamData) {
    const _formattedExamSessionBeginDate =
        values.examSessionBeginDate && values.examSessionBeginDateTime
            ? Moment(
                values.examSessionBeginDate,
                _common.findDateFormat(props.userPreferences) + ' ' + values.examSessionBeginDateTime,
                window.appSettings.DefaultDateTimeFormat
            )
            : '';
    values.examSessionBeginDate = _formattedExamSessionBeginDate
        ? Moment(_formattedExamSessionBeginDate)
            .set({
                h: Moment(values.examSessionBeginDateTime, window.appSettings.DefaultDateTimeFormat).get('hour'),
                m: Moment(values.examSessionBeginDateTime, window.appSettings.DefaultDateTimeFormat).get('minute')
            }).format(window.appSettings.DefaultDateFormatApi)
        : '';

    const _formattedExamSessionEndDate =
        values.examSessionEndDate && values.examSessionEndDateTime
            ? Moment(
                values.examSessionEndDate,
                _common.findDateFormat(props.userPreferences) + ' ' + values.examSessionEndDateTime,
                window.appSettings.DefaultDateTimeFormat
            )
            : '';
    values.examSessionEndDate = _formattedExamSessionEndDate
        ? Moment(_formattedExamSessionEndDate)
            .set({
                h: Moment(values.examSessionEndDateTime, window.appSettings.DefaultDateTimeFormat).get('hour'),
                m: Moment(values.examSessionEndDateTime, window.appSettings.DefaultDateTimeFormat).get('minute')
            }).format(window.appSettings.DefaultDateFormatApi)
        : '';

    const _formattedExamShowAnswerSpecifiedDate =
        values.examShowAnswerSpecifiedDate && values.examShowAnswerSpecifiedDateTime
            ? Moment(
                values.examShowAnswerSpecifiedDate,
                _common.findDateFormat(props.userPreferences) + ' ' + values.examShowAnswerSpecifiedDateTime,
                window.appSettings.DefaultDateTimeFormat
            )
            : '';
    values.examShowAnswerSpecifiedDate = _formattedExamShowAnswerSpecifiedDate
        ? Moment(_formattedExamShowAnswerSpecifiedDate)
            .set({
                h: Moment(values.examShowAnswerSpecifiedDateTime, window.appSettings.DefaultDateTimeFormat).get('hour'),
                m: Moment(values.examShowAnswerSpecifiedDateTime, window.appSettings.DefaultDateTimeFormat).get('minute')
            }).format(window.appSettings.DefaultDateFormatApi)
        : '';

    if (values.examQuestionWeightingType !== -1) {
        if (values.examQuestionWeightingType === ExamQuestionWeightingType.Difficulty && (!values.examDifficulties || (values.examDifficulties && !values.examDifficulties.length))) {
            values.examQuestionWeights = [];
        }

        if (values.examQuestionWeightingType === ExamQuestionWeightingType.Topic && (!values.examTopics || (values.examTopics && !values.examTopics.length))) {
            values.examQuestionWeights = [];
        }
    } else {
        values.examQuestionWeights = [];
    }
}

export function initProjectSubmitData(props: any, values: any, activityType: ActivityTypeEnums, state?: any) {
    values.allowDownload = true;
    values.isGroupProject = state.isGroupProject;
    values.groupList = state.groups.map((group: any) => {
        return {
            groupId: group.hashedGroupId,
            activityId: ''
        };
    });
    values.activityList = values.subActivities.map((activity: any) => {
        const formattedTime =
            activity.deadline && activity.deadlineTime
                ? Moment(
                    activity.deadline,
                    _common.findDateFormat(props.userPreferences) + ' ' + activity.deadlineTime,
                    window.appSettings.DefaultDateTimeFormat
                )
                : '';

        const deadline = formattedTime
            ? Moment(formattedTime)
                .set({
                    h: Moment(activity.deadlineTime, window.appSettings.DefaultDateTimeFormat).get('hour'),
                    m: Moment(activity.deadlineTime, window.appSettings.DefaultDateTimeFormat).get('minute')
                })
                .format(window.appSettings.DefaultDateFormatApi)
            : '';
        const subValue: any = defaultValueForActivity(activity.activityType);
        // aktivite güncellenicek ise activityId eklenmeli - subValue.activityId = '31231..';
        // subValue.name = activity.name;
        subValue.taskDeadLine = deadline;
        subValue.isCommon = 1;
        subValue.isProjectActivity = true;
        // forum
        subValue.hasModerator = false;
        // video 
        subValue.videoType = values.videoType !== VideoType.Local ? _common.getVideoType(values.fileEmbed) : VideoType.Local;
        subValue.courseId = props.coursePageActivityId;
        return {
            hashedProjectActivityId: activity.hashedProjectActivityId,
            activityType: activity.activityType,
            deadline,
            subActivity: subValue
        };
    });
}

function prerequisiteActivityHours(values: any)
{
    if (values.datePrerequisiteActivityId)
    {
        return 0;
    }
    else
    {
        return "";
    }
}

function datePrerequisiteActivityId(values: any)
{

    if (values.datePrerequisiteActivityId)
    {
        return values.datePrerequisiteActivityId[0].value;
    }
    else
    {
        return values.datePrerequisiteActivityId;
    }
}

function defaultValueForActivity(activityType: ActivityTypeEnums) {
    switch (activityType) {
        case ActivityTypeEnums.Assignment:
            return GlobalState().assignment.AssignmentData;
        case ActivityTypeEnums.Document:
            return GlobalState().document.DocumentData;
        case ActivityTypeEnums.Forum:
            return GlobalState().forum.forumData;
        case ActivityTypeEnums.VirtualClass:
            return GlobalState().virtualClass.VirtualClassData;
        case ActivityTypeEnums.Video:
            return GlobalState().video.videoData;
        default:
            return null;
    }
}

// dosya yükleme alaninda yukle butonu gorunuyorsa dondur true|false
export function checkFileUploadEmpty(deletedFile?: boolean) {
    if(deletedFile)
    {
        return false;
    }
    const uploadFileButonExist = document.getElementsByClassName('uppy-StatusBar-actionBtn--upload');
    const isExists = uploadFileButonExist.length === 1 ? false : true;
    return isExists;
}
